import React from 'react';
import { useSelector } from 'react-redux';

import { ContainerDiv, ContentDiv, Span } from './styles';

export function FiltroBar() {
	const { user } = useSelector((state) => state.auth);

	return (
		<ContainerDiv>
			<ContentDiv>
				<Span>Filtrado por:</Span>
				<Span>{user.dados.nome}</Span>
			</ContentDiv>
		</ContainerDiv>
	);
}
